import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as moment from 'moment';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { CalendarOptions } from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es'; // ✅ esta ruta sí existe
import tippy from 'tippy.js';
import { FullCalendarComponent } from '@fullcalendar/angular';

@Component({
  selector: 'app-hotelplaning',
  templateUrl: './hotelplaning.component.html',
  styleUrls: ['./hotelplaning.component.css']
})
export class HotelplaningComponent implements OnInit {
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  // variables
  Math = Math; // 👈 Esto habilita el uso de Math en el template
  eventObj: any = null;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  occupancy: any = 0;
  total_bookings: any = 0;
  total_pax: any = 0;
  total_nights: any = 0;
  nights_month: any = 0;
  start_range: any = moment();
  end_range: any = moment().endOf('month');
  date_now: any = moment().format('YYYY-MM-DD');

  calendarOptions: CalendarOptions = {
    plugins: [resourceTimelinePlugin, interactionPlugin],
    initialView: 'resourceTimelineMonth',
    // initialDate: new Date(), // 📅 Establece la fecha actual como inicio
    // nowIndicator: true, // 🔴 Muestra una línea roja con la hora actual (si tu vista tiene horas)
    locale: esLocale,
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'resourceTimelineMonth'
    },
    slotMinWidth: 30,
    // slotDuration: '12:00:00', // 👈 cada slot dura 12 horas (mañana / tarde)
    // slotLabelInterval: '12:00',
    // slotMinTime: '00:00:00',
    // slotMaxTime: '24:00:00',
    contentHeight: 500,
    resourceAreaWidth: '100px',
    resourceAreaHeaderContent: 'Habitaciones',
    // 🔹 Personalización del texto de la habitación + variaciones
    resourceLabelContent: arg => {
      const variations = arg.resource.extendedProps['bedroom_variations'] || [];
      // Si bedroom_variations es un array de objetos
      const textoVariaciones = variations.length
        ? variations.map((v: any) => v.roomtype.abbreviation).join(' / ')
        : '';
      return {
        html: `
        <div style="
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: center; 
        height: 100%;
        text-align: center;
      ">
          <span style="font-weight: 600;">${arg.resource.title}</span>
          ${
            textoVariaciones
              ? `<span style="font-size: 10px; color: #777;">${textoVariaciones}</span>`
              : ''
          }
        </div>
      `
      };
    },
    resources: [], // se llenará dinámicamente
    events: [], // se llenará dinámicamente
    eventDidMount: info => {
      const tooltipContent = `
        <div>
          <strong>${info.event.title}</strong>
        </div>
      `;
      // const tooltipContent = `
      //   <div>
      //     <strong>${info.event.title}</strong><br>
      //     <small>
      //       Desde: ${info.event.start?.toLocaleDateString()}<br>
      //       Hasta: ${info.event.end?.toLocaleDateString()}
      //     </small>
      //   </div>
      // `;
      tippy(info.el, {
        content: tooltipContent,
        allowHTML: true,
        theme: 'light-border',
        placement: 'top',
        animation: 'shift-away',
        delay: [50, 30]
      });
    },
    // eventDidMount: info => {
    //   // Añade un tooltip básico nativo del navegador
    //   info.el.setAttribute('title', info.event.title);
    // },
    datesSet: info => {
      this.start_range = moment(info.startStr);
      this.end_range = moment(info.endStr);
      this.list();
    },
    eventClick: info => {
      info.jsEvent.preventDefault();
      // Aquí puedes acceder a todos los datos del evento
      const event = info.event;
      // const reserva = info.event.extendedProps;
      // Si quieres mostrar datos extendidos:
      const detalles = {
        id: event.id,
        titulo: event.title,
        inicio: event.start?.toLocaleDateString(),
        fin: event.end?.toLocaleDateString(),
        color: event.backgroundColor,
        ...event.extendedProps // Incluye datos adicionales (tipo, estado, etc.)
      };

      this.eventObj = detalles;
      console.log(this.eventObj);
      setTimeout(() => {
        (<any>$('#modalEventBooking')).modal('show');
      }, 50);
    }
  };

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private hotelbookingService: HotelbookingsService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    // this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD');

    this.hotelbookingService.planning(val_params).subscribe({
      next: (data: any) => {
        // console.log('recibiendo datos');
        console.log(data);

        // 🔹 Cargar habitaciones (resources)
        const newResources = data.results.map((habitacion: any) => ({
          id: habitacion.id.toString(),
          title:
            habitacion.code_number + ' -' + habitacion.roomtype.abbreviation,
          bedroom_variations: habitacion.bedroom_variations || []
        }));

        // 🔹 Actualizar los eventos (reservas)
        const newEvents = data.events_data.map((ev: any) => ({
          id: ev.id.toString(),
          resourceId: ev.resourceId.toString(),
          start: ev.start,
          end: ev.end,
          number_nights: ev.number_nights,
          nro_pax: ev.nro_pax || 0,
          title: ev.title,
          color: ev.color || '#74b9ff',
          code_number: ev.code_number,
          checkin_status: ev.checkin_status,
          extendedProps: ev.extendedProps || {}
        }));

        // ⚙️ Calcular ocupabilidad
        const totalRooms = newResources.length;
        const start = new Date(this.start_range.format('YYYY-MM-DD'));
        const end = new Date(this.end_range.format('YYYY-MM-DD'));
        const totalDays = Math.ceil(
          (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
        );

        const totalRoomNights = totalRooms * totalDays;
        this.nights_month = totalRoomNights;
        const occupiedNights = newEvents.reduce(
          (sum: any, ev: any) => sum + (ev.number_nights || 0),
          0
        );

        this.occupancy = Math.min(
          100,
          Math.round((occupiedNights / totalRoomNights) * 100)
        );

        this.total_bookings = newEvents.length;

        // ⚙️ Calcular total de pasajeros
        const total_pax = newEvents.reduce(
          (sum: any, ev: any) => sum + (Number(ev.nro_pax) || 0),
          0
        );

        this.total_pax = total_pax;

        // ⚙️ Calcular total de noches
        const total_nights = newEvents.reduce(
          (sum: any, ev: any) => sum + (Number(ev.number_nights) || 0),
          0
        );

        this.total_nights = total_nights;

        // 🔹 Actualizar dinámicamente el calendario
        this.calendarOptions = {
          ...this.calendarOptions,
          resources: newResources,
          events: newEvents
        };

        // ✅ Esperas un pequeño tiempo para asegurarte de que el calendario ya se renderizó
        // setTimeout(() => {
        //   const calendarApi = this.calendarComponent?.getApi(); // 👈 Obtén el API del calendario
        //   if (calendarApi) {
        //     const today = moment().format('YYYY-MM-DD'); // Fecha actual
        //     calendarApi.gotoDate(today); // 📅 Mueve la vista hacia la fecha actual
        //   }
        // }, 300);
      },
      error: err => {
        console.error('❌ Error al cargar planificación:', err);
      }
    });
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  closeModalEventObj() {
    (<any>$('#modalEventBooking')).modal('hide');
    this.eventObj = null;
  }

}
